import { Flex } from 'antd';
import { Card, Skeleton } from '@common-web';
import { showResetButton } from '../../helper';

const FiltersCardSkeleton = ({ filterChips, location }) => {
  return (
    <Card
      styles={{
        body: {
          '--ant-padding-lg': 'var(--ant-padding)',
        },
      }}
    >
      <Flex vertical gap={12}>
        {filterChips.length > 0 && (
          <Flex align="center" justify="space-between">
            <Flex align="center" gap={12} className="flexGrow">
              <Flex wrap="wrap" gap={12}>
                <Skeleton height={25} width={95} />

                {filterChips.map((item) => {
                  return <Skeleton height={25} width={75} style={{ borderRadius: 55 }} key={item?.searchKey} />;
                })}
                {showResetButton(location) && <Skeleton height={30} width={75} />}
              </Flex>
            </Flex>
            <Skeleton height={30} width={130} />
          </Flex>
        )}
        <Flex justify="space-between">
          <Flex gap={12}>
            <Skeleton height={25} width={95} />
            {[1, 2, 3].map((item) => {
              return <Skeleton height={25} width={75} style={{ borderRadius: 55 }} key={item} />;
            })}
          </Flex>
          <Skeleton height={30} width={100} />
        </Flex>
      </Flex>
    </Card>
  );
};

export default FiltersCardSkeleton;
